<template>
    <div class="modal fade" :id="modalId" tabindex="-1" ref="base-modal">
        <div :class="modalDialogClassNames">
            <div class="modal-content">
                <div class="modal-header">
                    <slot name="title" />
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-if="modalCloseButton">
                        <svg width="24" height="24">
                            <use xlink:href="/sprite.svg#icon-close"></use>
                        </svg>
                    </button>
                </div>
                <slot v-bind="{ hide, show, isOpen }" />
            </div>
        </div>
    </div>
</template>

<script>

const { eventBus } = window.specialtyApp;

export default {
    name: 'base-modal',

    data() {
        return {
            isOpen: false,
            relatedTarget: null,
        };
    },

    props: {
        modalId: {
            type: String,
            required: false,
        },

        modalDialog: {
            type: String,
            default: 'centered,common',
        },

        modalCloseButton: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        initInnerHandlers() {
            const $modal = $(this.$el);

            $modal.on('shown.bs.modal', () => {
                $('[data-focus-on-modal-show]').focus();
            });

            $modal.on('show.bs.modal', () => {
                this.$emit('related-modal-target', {
                    target: this.relatedTarget,
                });
            });
        },

        initCloseHandlers() {
            const $modal = $(this.$el);

            $modal.on('hide.bs.modal', () => {
                this.$emit('close-modal');
            });
        },

        show() {
            $(this.$el).modal('show');
            this.isOpen = true;
        },

        hide() {
            $(this.$el).modal('hide');
            this.isOpen = false;
        },

        changeClassNameHandler(classAttrValue) {
            const classList = classAttrValue.split(' ');
            this.isOpen = classList.includes('show');
        },

        observeModalClassNames() {
            const element = this.$refs['base-modal'];
            if (!element) return;

            const observer = new MutationObserver((mutations) => {
                // eslint-disable-next-line no-restricted-syntax
                for (const m of mutations) {
                    const newValue = m.target.getAttribute(m.attributeName);

                    this.$nextTick(() => {
                        this.changeClassNameHandler(newValue, m.oldValue);
                    });
                }
            });

            observer.observe(element, {
                attributes: true,
                attributeOldValue: true,
                attributeFilter: ['class'],
            });
        },

        isOpened() {
            this.$emit('open', {
                open: this.isOpen,
            });
        },
    },

    computed: {
        modalDialogClassNames() {
            const additionalClasses = {};
            const classPostfixes = this.modalDialog.split(',');

            classPostfixes.forEach((postfix) => {
                additionalClasses[`modal-dialog-${postfix}`] = true;
            });

            return {
                'modal-dialog': true,
                ...additionalClasses,
            };
        },
    },

    mounted() {
        this.initInnerHandlers();
        this.observeModalClassNames();
        this.initCloseHandlers();
    },

    beforeDestroy() {
        this.observer.disconnect();
    },

    watch: {
        isOpen: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.isOpened();
                }

                eventBus.$emit('modal-opened', {
                    isModalOpened: this.isOpen,
                });
            },
        },
    },
};
</script>
